export default __webpack_public_path__ + "static/media/bath.164e903e.svg";